<template>
    <div class="page">
        <!--<div class="page-hd">-->
            <!--<myNav>{{title}}</myNav>-->
        <!--</div>-->
        <div class="page-bd">
            <Button type="primary" @click="openSave('add',$t('root'))">{{$t("add_sub")}}</Button>
            <div class="tree-box">
                <div v-for="item in listData" :key="item.func_id">
                    <span><Icon class="left-icon" type="ios-arrow-down" />{{item.func_cname}}({{item.func_id}})
                        <span class="tag primary fr" @click="openSave('upd',item.func_cname,item.func_id)">{{$t("info")}}</span>
                        <span class="tag primary fr" @click="openSave('add',item.func_cname,item.func_id)">{{$t("add_sub")}}</span>
                    </span>
                    <div class="sub-tree c1" v-for="item2 in item.children" :key="item2.func_id">
                        <span><Icon class="left-icon" type="ios-arrow-down" />{{item2.func_cname}}({{item2.func_id}})
                            <span class="tag primary" @click="openSave('add',item.func_cname+'>'+item2.func_cname,item2.func_id)">{{$t("add_sub")}}</span>
                            <span class="tag primary" @click="openSave('upd',item.func_cname+'>'+item2.func_cname,item2.func_id)">{{$t("info")}}</span>
                        </span>
                        <div class="sub-tree c2" v-for="item3 in item2.children" :key="item3.func_id">
                            <span><Icon class="left-icon" type="ios-appstore" />{{item3.func_cname}}({{item3.func_id}})
                                <span class="tag primary" @click="openSave('upd',item.func_cname+'>'+item2.func_cname+'>'+item3.func_cname,item3.func_id)">{{$t("info")}}</span>
                            </span  >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="720" :mask-closable="false" placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myNav from "../../components/myNav"
    import myToolbar from '../../components/myToolbar'
    import myNodata from '../../components/myNodata'
    export default {
        name:'system-func',
        components:{
            myNav,
            myToolbar,
            myNodata,
        },
        data:function(){
            return{
                title: this.$t('system_func_title'),
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                search:{
                    search_url:'func/list'
                },
                listTable: {},//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.list();
        },
        methods:{
            list: function () {
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list;
                        // this.search.pageSize = parseInt(data.last_page);
                        // this.totalData.total = data.total.total;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openSave:function (op, name, id) {
                var title = "";
                if(op == "add"){
                    title = this.$t("add_sub") + "(" + name + ")";
                }
                else if(op == "upd"){
                    title = this.$t("upd") + "(" + name + ")";
                }
                else if(op == "addUser"){
                        title = this.$t("upd") + "(" + name + ")";
                }
                this.sub_title = title;
                this.$base.linkTo("/system/func/save",{op: op,id: id});
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
    .tree-box{
        max-width: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/system/func.vue